export default "__VITE_ASSET__DBM0YODB__"